import { Controller } from "@hotwired/stimulus";
import { handleHttpResponse } from "../../../utils/http_utils";
import { notifyError } from "../../../components/flash_alert";

export default class extends Controller {
  salesUpdated(event) {
    const payload = event.detail[0];

    handleHttpResponse({
      payload: payload,
      onSuccess: (response) => {
        const salesInvoices = JSON.parse(response).sales_invoices;
        document.dispatchEvent(new CustomEvent("salesInvoice:updated", { detail: { salesInvoices: salesInvoices } }));
      },
      onError: () => {
        const { message } = JSON.parse(payload.response);
        notifyError(message);
      },
    });
  }
}
